module.exports = __webpack_public_path__ + "static/media/logo.e95e232b.png";